import engineApi from './engine.service';
import api from './base.service';

export const getDailyAll = () => {
    return api().get(`/api/daily-schedules/mobile/content`);
};



